<template>
<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22.2234 0.0976562H1.77187C0.792187 0.0976562 0 0.871094 0 1.82734V22.3633C0 23.3195 0.792187 24.0977 1.77187 24.0977H22.2234C23.2031 24.0977 24 23.3195 24 22.368V1.82734C24 0.871094 23.2031 0.0976562 22.2234 0.0976562ZM7.12031 20.5492H3.55781V9.09297H7.12031V20.5492ZM5.33906 7.53203C4.19531 7.53203 3.27188 6.60859 3.27188 5.46953C3.27188 4.33047 4.19531 3.40703 5.33906 3.40703C6.47813 3.40703 7.40156 4.33047 7.40156 5.46953C7.40156 6.60391 6.47813 7.53203 5.33906 7.53203ZM20.4516 20.5492H16.8937V14.9805C16.8937 13.6539 16.8703 11.943 15.0422 11.943C13.1906 11.943 12.9094 13.3914 12.9094 14.8867V20.5492H9.35625V9.09297H12.7687V10.6586H12.8156C13.2891 9.75859 14.4516 8.80703 16.1813 8.80703C19.7859 8.80703 20.4516 11.1789 20.4516 14.2633V20.5492Z" fill="white"/>
</svg>


</template>

<script setup lang="ts">

</script>

<style lang="scss" >
</style>